/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState } from 'react';
import Input from 'components/Fields/Input';

import { useSpecSheet } from 'containers/spec-sheet';
import { useDebounce } from 'hooks/useDebounce';

const OriginalBaseRef: React.FC = () => {
  const {
    data: { data },
    actions,
  } = useSpecSheet();

  const originalBaseRef = data?.originalBaseRef || '';

  const [value, setValue] = useState(originalBaseRef);

  const handleChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setValue(value);
  };

  const saveChange = async () =>
    actions.changeSpecSheetData({ originalBaseRef: value.trim() });

  const autoSave = useDebounce(value);

  const handleSave = () => {
    if (originalBaseRef !== value) saveChange();
  };

  useEffect(() => {
    handleSave();
  }, [autoSave]);

  const isCompleted = !!value;

  return (
    <Input
      label="Original base ref#"
      value={value}
      name="original-base-ref"
      onChange={handleChange}
      dataTest="original-base-ref"
      isCompleted={isCompleted}
      handleBlur={() => handleSave()}
      placeholder="Click to add"
    />
  );
};

export default OriginalBaseRef;
